import { isValidPhoneNumber } from "libphonenumber-js";
import { z } from "zod";

export const TITLE = "Change Phone Number";
export const DESCRIPTION =
  "Please enter your new phone number. This number will be used for future logins.";
export const SG_DIAL_CODE = "+65";
export const FOREIGN_NUMBER_CS_MESSAGE =
  "Hi! I want to change my SG phone number to foreign phone number. Could you please help me with this?";

export const changePhoneNumberSchema = z.object({
  currentPhoneNumber: z.string(),
  newPhoneNumber: z.string().refine(isValidPhoneNumber, "Invalid phone number"),
});
